import React, { useRef, useState, useMemo, useEffect } from "react";
// import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import striptags from "striptags";
import Link from "next/link";
import Image from "next/image";
import { parseHtml } from "../../../utils/common";

import arrow_icon from "../../../public/assets/images/arrow-icon.svg";

const Specialities = ({ industryData }) => {
  const containerRef = useRef(null);
  const dropdownRef = useRef(null);

  const [activeTab, setActiveTab] = useState(0);
  const [activeTabTitle, setActiveTabTitle] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const handleTabClick = (tabId) => {
    const container = containerRef.current;
    if (!container) return;
   
    const tabElements = container.children;
    if (tabElements[tabId]) {
      (tabElements[tabId]).scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
    setActiveTab(tabId);
    setIsOpen(false);
  };

  const tabs = useMemo(()=>{
    return (industryData?.value?.list || [])?.length;
  },[industryData]);

  const handlePrevButtonClick = () => {
    handleTabClick(activeTab === 0 ? tabs - 1 : activeTab - 1);
  };

  const handleNextButtonClick = () => {
    handleTabClick(activeTab === tabs - 1 ? 0 : activeTab + 1);
  };

  useEffect(()=>{
    setActiveTabTitle(industryData?.value?.list?.[activeTab]?.value?.title || "")
  },[activeTab,industryData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(()=>{
    setActiveTab(0);
    setIsOpen(false);
  },[industryData]);

  const titleWithoutPTag = industryData?.value?.title;

  return (
    <section className="our-specialities-section">
      <div className="our-specialities-inner">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="section-heading">
                <span
                  itemProp="heading"
                  dangerouslySetInnerHTML={{
                    __html: titleWithoutPTag,
                  }}
                ></span>
                <p
                  itemProp="description"
                  dangerouslySetInnerHTML={{
                    __html: industryData?.value?.description,
                  }}
                ></p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-lg-12 col-md-12 col-sm-12">
              <div className="our-specialities-details">
                <div className="swiper-arrow">
                    <div
                      className={`swiper-prev ${activeTab == 0 ? `disabled`: ''}`}
                      onClick={activeTab !== 0 ? handlePrevButtonClick : null}
                    ></div>
                    <div
                      className={`swiper-next ${activeTab == (tabs-1) ? `disabled`: ''}`}
                      onClick={activeTab !== (tabs-1) ? handleNextButtonClick : null}
                    ></div>
                </div>
                <div className="our-specialities-tab">
                  <ul
                    ref={containerRef}
                    className="nav nav-pills mb-3"
                    id="pills-tab"
                    role="tablist"
                  >
                    {industryData?.value?.list?.map((val, index) => {
                      return (
                        <li
                          className="nav-item"
                          role="presentation"
                          key={`${index}_j`}
                        >
                          <button
                            className={`nav-link ${
                              activeTab === index ? "active" : ""
                            }`}
                            onClick={() => handleTabClick(index)}
                            // className="nav-link active link-font-lg"
                            id="pills-home-tab"
                            data-bs-toggle="pill"
                            data-bs-target={`#${index}`}
                            type="button"
                            role="tab"
                            aria-controls={index}
                            aria-selected="true"
                            dangerouslySetInnerHTML={{
                              __html: striptags(val?.value?.title),
                            }}
                          ></button>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div className="our-specialities-tab-dp" ref={dropdownRef}>
                  <div className="tabs-dp-header" onClick={()=>{setIsOpen(!isOpen)}}>
                    <p 
                      dangerouslySetInnerHTML={{
                        __html: striptags(activeTabTitle)
                      }}>
                    </p>
                    <div className={`tabs-dp-icon ${isOpen ? 'active': ''}`}>
                      <Image
                        height={16}
                        width={16}
                        src={arrow_icon}
                        alt="a"
                      />
                    </div>
                  </div>
                  <div className={`tabs-dp-options ${isOpen ? 'active': ''}`}>
                    {industryData?.value?.list?.map((val, index) => {
                        return (
                          <button
                            className={`nav-link ${
                              activeTab === index ? "active" : ""
                            }`}
                            onClick={() => handleTabClick(index)}
                            id="pills-home-tab"
                            data-bs-toggle="pill"
                            data-bs-target={`#${index}`}
                            type="button"
                            role="tab"
                            aria-controls={index}
                            aria-selected="true"
                            dangerouslySetInnerHTML={{
                              __html: striptags(val?.value?.title),
                            }}
                            key={`${index}_h`}
                          ></button>
                        );
                      })}
                  </div>
                </div>
                <div className="our-specialities-content">
                  <div className="tab-content" id="pills-tabContent">
                    {industryData?.value?.list?.map((val, index) => {
                      return (
                        <div
                          // className="tab-pane fade show active"
                          className={`tab-pane fade ${
                            activeTab === index ? "show active" : ""
                          }`}
                          id={index}
                          role="tabpanel"
                          aria-labelledby="pills-home-tab"
                          key={`${index}_j`}
                          // tabIndex="0"
                        >
                          <div className="specialities-tab-content">
                            <div className="row">
                              <div className="col-md-6">
                                <div className="specialities-content-left">
                                  <div className="specialities-description">
                                    <span
                                      className="specialities-title heading-h3 h3-span-bold"
                                      itemProp="heading"
                                      dangerouslySetInnerHTML={{
                                        __html: striptags(val?.value?.title),
                                      }}
                                    ></span>

                                    {parseHtml(val?.value?.description)}
                                  </div>
                                  <div className="specialities-btn">
                                    <Link
                                      href={
                                        val?.value?.page_chooser_block?.page
                                          ?.url || ""
                                      }
                                      className="btn btn-primary"
                                      itemProp="link"
                                    >
                                      {val?.value?.page_chooser_block?.title}
                                    </Link>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="specialities-content-right">
                                  <Image
                                    height={1000}
                                    width={1000}
                                    src={val?.value?.image?.url}
                                    alt={val?.value?.image?.alt_text ?? 'Blockchain'}
                                    loading="eager"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Specialities;
